import { networkCall } from "../../../../../util/network-call/network-call";

export const InstructorEducationListLoader = async () => {

    const response = await networkCall(`/educations`);

    return { getEducationsResponse: response };

};